import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import { store } from '@/stores'

import DashboardPage from '@/pages/dashboard/master/dashboard.vue'
import FeedPage from "@/pages/feed/master/feed.vue";
import ProfilePage from "@/pages/profile/master/profile.vue";
import ProfilePublicPage from "@/pages/profile-public/master/profile-public.vue";
import ProfilePublicFromTagPage from "@/pages/profile-public-from-tag/master/profile-public-from-tag.vue";
import LoginPage from "@/pages/login/master/login.vue";

import BannedPage from "@/pages/administration/banned/master/banned.vue";
import SuspendedPage from "@/pages/administration/suspended/master/suspended.vue";
import DeletionPage from "@/pages/administration/deletion/master/deletion.vue";

import AppSettingsPage from "@/pages/administration/admin/app-settings/master/app-settings.vue";
import AppUsersPage from "@/pages/administration/admin/app-users/master/app-users.vue";
import AppReportedUsersPage from "@/pages/administration/admin/app-reported-users/master/app-reported-users.vue";
import AppEditUser from "@/pages/administration/admin/app-edit-user/master/app-edit-user.vue";
import AppDashboardPage from "@/pages/administration/admin/app-view-dashboard/master/app-view-dashboard.vue";
import AppTagsPage from "@/pages/administration/admin/app-tags/master/app-tags.vue";
import AppCreateAdvertisementPage from "@/pages/administration/admin/app-create-advertisement/master/app-create-advertisement.vue";
import AppAdvertisementsPage from "@/pages/administration/admin/app-advertisements/master/app-advertisements.vue";
import AppEditAdvertisementsPage from "@/pages/administration/admin/app-edit-advertisement/master/app-edit-advertisement.vue";

Vue.use(Router)

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            redirect: '/dashboard'
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginPage,
            meta: {
                guest: true,
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: DashboardPage,
            meta: {
                auth: true
            }
        },
        {
            path: '/feed',
            name: 'Feed',
            component: FeedPage,
            meta: {
                auth: true
            }
        },
        {
            path: '/profile/:userId',
            name: 'Profile',
            component: ProfilePage,
            meta: {
                authToDetermine: true,
            }
        },
        {
            path: '/profile-authenticated/:userId',
            name: 'ProfileAuthenticated',
            component: ProfilePage,
            meta: {
                auth: true,
            }
        },
        {
            path: '/profile-view-from-dynamic-link/:userId',
            name: 'ProfileDynamicLink',
            component: ProfilePage,
            meta: {
                authToDetermine: true,
            }
        },
        {
            path: '/profile-public/:userId',
            name: 'ProfilePublic',
            component: ProfilePublicPage,
        },
        {
            path: '/tags-view-from-dynamic-link/:tagId',
            name: 'ProfilePublicFromTag',
            component: ProfilePublicFromTagPage,
        },
        {
            path: '/banned',
            name: 'Banned',
            component: BannedPage,
            meta: {
                auth: true
            }
        },
        {
            path: '/suspended',
            name: 'Suspended',
            component: SuspendedPage,
            meta: {
                auth: true
            }
        },
        {
            path: '/deletion',
            name: 'Deletion',
            component: DeletionPage,
            meta: {
                auth: true
            }
        },
        {
            path: '/appSettings',
            name: 'AppSettings',
            component: AppSettingsPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appUsers',
            name: 'AppUsers',
            component: AppUsersPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appEditUser/:userId',
            name: 'AppEditUser',
            component: AppEditUser,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appViewDashboard',
            name: 'AppViewDashboard',
            component: AppDashboardPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appReportedUsers',
            name: 'AppReportedUsers',
            component: AppReportedUsersPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appTags',
            name: 'AppTags',
            component: AppTagsPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appAdvertisements',
            name: 'AppAdvertisements',
            component: AppAdvertisementsPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appCreateAdvertisement',
            name: 'AppCreateAdvertisement',
            component: AppCreateAdvertisementPage,
            meta: {
                admin: true,
            }
        },
        {
            path: '/appEditAdvertisement/:advertisementId',
            name: 'AppEditAdvertisement',
            component: AppEditAdvertisementsPage,
            meta: {
                admin: true,
            }
        }
    ]
},)

/**
 * Assuring the user is correctly logged to Firebase Auth
 * Before sending him to any page of the application
 * If the user is not logged in, then we send him to the login page
 * So he can proceed to login
 */
router.beforeEach((to, from, next) => {
    const isAdmin = store.getters['user/isAdmin'];
    if (to.matched.some(record => record.meta.auth)) {
        if(firebase.auth().currentUser != null) next()
        else {
            next({
                path: "/login",
            })
        }
    }
    else if (to.matched.some(record => record.meta.guest)) {
        if(firebase.auth().currentUser != null) {
            next({
                path: "/dashboard",
            })
        }
        else next()
    }
    else if (to.matched.some(record => record.meta.admin)) {
        if(isAdmin) {
            next()
        }
        else {
            next({
                path: "/dashboard",
            })
        }
    }
    else if (to.matched.some(record => record.meta.authToDetermine)) {
        if(firebase.auth().currentUser != null) {
            next({
                name: 'ProfileAuthenticated',
                params: {
                    userId: to.params.userId
                }
            })
        }
        else {
            next({
                name: 'ProfilePublic',
                params: {
                    userId: to.params.userId
                }
            })
        }
    }
    else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js